export default {
  '81eea5776173a422388a81ab72c494eb':
    'Order confirmation counter - Payment result confirmation pop-up window',
  '1444fb889c027d8288644d53f7003ffc': 'Waiting for payment...',
  '9cea2f350bb96b1a934cc871b4679f4b': 'Successed. Acess now',
  '38e2bea31f0c67f23dcb0ef1a76e2037': 'Failed. Try again'
};
